import whyUsIcon1 from "assets/tiles/why-rolling-block/why-rb-icon-1.svg";
import whyUsIcon2 from "assets/tiles/why-rolling-block/why-rb-icon-2.svg";
import whyUsIcon3 from "assets/tiles/why-rolling-block/why-rb-icon-3.svg";
import whyUsIcon4 from "assets/tiles/why-rolling-block/why-rb-icon-4.svg";
import whyInvestIcon1 from "assets/tiles/why-invest/why-invest-icon-1.svg";
import whyInvestIcon2 from "assets/tiles/why-invest/why-invest-icon-2.svg";
import whyInvestIcon3 from "assets/tiles/why-invest/why-invest-icon-3.svg";
import whyInvestIcon4 from "assets/tiles/why-invest/why-invest-icon-4.svg";
import placeholderArticlePreview from "assets/articles/placeholder-article-preview.png";

export const heroInfo = {
  headerText: <>
            Make your services work for <em><span>EVERYONE</span></em> with Rolling Block
          </>,
  buttonText: "Everything you need to know",
  buttonUrl: "#hero-anchor",
  buttonIconAlt: "Down arrow",
};

export const whyAccessibility = [
  {
    imageUrl: whyInvestIcon1,
    header: "Access more customers",
    description:
      "1 in 6 people have a disability worldwide. Improving accessibility means opening the door to many more potential customers.",
  },
  {
    imageUrl: whyInvestIcon2,
    header: "A better experience for everyone",
    description: "Good accessibility doesn't just benefit those with access needs – it helps to provide a better user experience for all of your customers.",
  },
  {
    imageUrl: whyInvestIcon3,
    header: "Stand out against competitors",
    description: "Making your website accessible shows that you care about all of your customers – something that many of your competitors may be overlooking.",
  },
  {
    imageUrl: whyInvestIcon4,
    header: "Remain compliant with the law",
    description:
      "If your website excludes people with disabilities, you could be breaking the law under the Equality Act 2010.",
  },
];

export const helpingOtherBusinesses = [
  {
    articleUrl: "#",
    companyName: "Company A",
    header: "How accessibility helped a small business to take off",
    description:
      "Company A wanted to make their website accessible to all users.",
    linkText: "Read full case study",
    imageUrl: placeholderArticlePreview,
    imageAlt: "Abc",
  },
  {
    articleUrl: "#",
    companyName: "Company B",
    header: "Opening the door to more customers through accessibility",
    description:
      "Company B wanted to ensure their digital products met all necessary accessibility standards to serve a diverse user base effectively.",
    linkText: "Read full case study",
    imageUrl: placeholderArticlePreview,
    imageAlt: "Abc",
  },
];

export const didYouKnow = {
  headerText: "Did you know?",
  mainText: "You may still have to comply with EU Accessibility laws, even if your business is based in the UK.",
  buttonText: "Find out why",
  buttonUrl: "#",
};

export const whyRollingBlock = [
  {
    imageUrl: whyUsIcon1,
    header: "People are at the heart of what we do.",
    description: "Accessibility is nothing without people. Our work is done by humans, for humans, and that will never change.",
  },
  {
    imageUrl: whyUsIcon2,
    header: "We're far more than just Web Accessibility experts.",
    description: "All of our work is underpinned by years of Web Development and Design experience.",
  },
  {
    imageUrl: whyUsIcon3,
    header: "Always affordable, never compromising on quality.",
    description: "If a service isn't affordable, it isn't accessible. We strive to always provide great value service at a fair price.",
  },
  {
    imageUrl: whyUsIcon4,
    header: "Free after-project support, forever.",
    description: "You can tap into our accessibility knowledge at any point after the project, completely free of charge.",
  }
];

export const ourServices = [
  {
    header: "Accessibility compliance testing",
    description: "The best way to determine just how accessibile your service currently is. We'll perform a full review of your service, outlining any accessibility issues and how to fix them.",
    url: "#",
  },
  {
    header: "Web Design and Development solutions",
    description: "Whether you need a small improvement or a total redesign, our flexible Design and Development services can help make your service accessible to all users.",
    url: "#",
  },
  {
    header: "Staff training and workshops",
    description: "Quickly get your staff up-to-speed and compliant with accessibility best practices.",
    url: "#",
  },
  {
    header: "On-demand help and advice",
    description: "We offer flexible, on-demand consultancy services to help you with any accessibility issues you may face.",
    url: "#",
  }
];

export const getStarted = {
  headerText: "Have a question, or ready to get started?",
  buttonText: "See pricing & packages",
  buttonUrl: "#",
};